import gql from 'graphql-tag';

/** Reserved ordering key used by the server for the combined All view. */
export const USER_GUIDE_ORDER_ALL_KEY = '__ALL__';

export const AVAILABLE_USER_GUIDE_SCOPES = gql`
    query availableUserGuideScopes {
        availableUserGuideScopes
    }
`;

export const USER_GUIDE_ARTICLES_FOR_ORDERING = gql`
    query userGuideArticlesForOrdering($scopeKeys: [String!]!) {
        userGuideArticlesForOrdering(scopeKeys: $scopeKeys) {
            _id
            title
            publishDate
            userGuideScopes
        }
    }
`;

export const USER_GUIDE_SCOPES = gql`
    query userGuideScopes {
        userGuideScopes {
            _id
            version
            scope
            name
            weight
            createdAt
        }
    }
`;

export const USER_GUIDE_SCOPE_OPTIONS = gql`
    query userGuideScopeOptions {
        availableNeonScopes
        userGuideScopes {
            _id
            version
            name
            scope
            weight
        }
    }
`;

export const USER_GUIDE_SCOPE = gql`
    query findUserGuideScopeById($id: ID!) {
        document: findUserGuideScopeById(id: $id) {
            _id
            version
            scope
            name
            weight
            createdAt
        }
    }
`;

export const ADD_USER_GUIDE_SCOPE = gql`
    mutation addUserGuideScope($item: UserGuideScopeInputAdd!) {
        addUserGuideScope(item: $item) {
            _id
            version
            scope
            name
            weight
            createdAt
        }
    }
`;

export const EDIT_USER_GUIDE_SCOPE = gql`
    mutation editUserGuideScope($item: UserGuideScopeInputEdit!) {
        editUserGuideScope(item: $item) {
            _id
            version
            scope
            name
            weight
            createdAt
        }
    }
`;

export const DELETE_USER_GUIDE_SCOPE = gql`
    mutation deleteUserGuideScope($id: ID!) {
        deleteUserGuideScope(id: $id) {
            _id
        }
    }
`;

export const SAVE_USER_GUIDE_SCOPE_GROUP = gql`
    mutation saveUserGuideScopeGroup($item: UserGuideScopeGroupInput!) {
        saveUserGuideScopeGroup(item: $item) {
            _id
            version
            scope
            name
            weight
            createdAt
        }
    }
`;

export const DELETE_USER_GUIDE_SCOPE_GROUP = gql`
    mutation deleteUserGuideScopeGroup($ids: [ID!]!) {
        deleteUserGuideScopeGroup(ids: $ids)
    }
`;

export const REORDER_USER_GUIDE_SCOPE_GROUPS = gql`
    mutation reorderUserGuideScopeGroups($groupNames: [String!]!) {
        reorderUserGuideScopeGroups(groupNames: $groupNames)
    }
`;

export const REORDER_USER_GUIDES_IN_SCOPES = gql`
    mutation reorderUserGuidesInScopes($orders: [UserGuideOrderInput!]!) {
        reorderUserGuidesInScopes(orders: $orders)
    }
`;
